import _ from 'lodash';
import { VIEWS_MODULE_NAMESPACE } from '@/constants/modules';

export const initialState = () => ({
  bookMap: {
    options: {
      center: {
        lat: 0,
        lng: 0,
      },
    },
    pickUp: {
      lat: undefined,
      lng: undefined,
      icon: undefined,
    },
    dropOff: {
      lat: undefined,
      lng: undefined,
      icon: undefined,
    },
    informer: {
      open: false,
      content: undefined,
      position: {
        lat: 0,
        lng: 0,
      },
    },
    directionsRendererOptions: {
      // To change the color of the route
      // polylineOptions: {
      //   strokeColor: MAIN_ROUTE_COLOR_MAP,
      // },
    },
    directionsServiceRequestOptions: {},
    // Sometimes, the children components set the map's center before than
    // Geolocation Service is loaded. For this reason, we will not set
    // the map's center when his value is different of the default value.
    viewNeedsDefaultMapCenter: true,
  },
});

export const state = initialState();

export const MUTATIONS = {
  SET_BOOK_MAP_CENTER: 'setBookMapCenter',
  SET_BOOK_MAP_OPTIONS: 'setBookMapOptions',
  SET_PICK_UP_MARKER: 'setPickUpMarker',
  SET_DROP_OFF_MARKER: 'setDropOffMarker',
  SET_DIRECTIONS_RENDERER_OPTIONS: 'setDirectionsRendererOptions',
  SET_DIRECTIONS_SERVICE_REQUEST_OPTIONS: 'setDirectionsServiceRequestOptions',
  SET_INFORMER_CONTENT: 'setInformerContent',
  SET_INFORMER_DATA: 'setInformer',
  SET_INFROMER_POSITION: 'setInformerPosition',
  SET_RESET_INFORMER: 'setResetInformer',
  SET_VIEW_NEEDS_DEFAULT_MAP_CENTER: 'setViewNeedsDefaultCenter',
};
export const mutations = {
  [MUTATIONS.SET_BOOK_MAP_CENTER](state, payload = {}) {
    state.bookMap.options = {
      ...state.bookMap.options,
      center: payload,
    };
  },
  [MUTATIONS.SET_BOOK_MAP_OPTIONS](state, payload = {}) {
    state.bookMap.options = {
      ...state.bookMap.options,
      ...payload,
    };
  },
  [MUTATIONS.SET_PICK_UP_MARKER](state, payload = {}) {
    state.bookMap.pickUp = {
      ...state.bookMap.pickUp,
      ...payload,
    };
  },
  [MUTATIONS.SET_DROP_OFF_MARKER](state, payload = {}) {
    state.bookMap.dropOff = {
      ...state.bookMap.dropOff,
      ...payload,
    };
  },
  [MUTATIONS.SET_DIRECTIONS_RENDERER_OPTIONS](state, payload = {}) {
    state.bookMap.directionsRendererOptions = {
      ...state.bookMap.directionsRendererOptions,
      ...payload,
    };
  },
  [MUTATIONS.SET_DIRECTIONS_SERVICE_REQUEST_OPTIONS](state, payload = {}) {
    state.bookMap.directionsServiceRequestOptions = {
      ...state.bookMap.directionsServiceRequestOptions,
      ...payload,
    };
  },
  [MUTATIONS.SET_INFORMER_CONTENT](state, payload = '') {
    state.bookMap.informer.content = payload;
  },
  [MUTATIONS.SET_INFROMER_POSITION](state, payload = {}) {
    state.bookMap.informer.position = {
      ...state.bookMap.informer.position,
      ...payload,
    };
  },
  [MUTATIONS.SET_INFORMER_DATA](state, payload = {}) {
    state.bookMap.informer = {
      ...state.bookMap.informer,
      ...payload,
    };
  },
  [MUTATIONS.SET_RESET_INFORMER](state) {
    state.bookMap.informer = {
      ...initialState().bookMap.informer,
    };
  },
  [MUTATIONS.SET_VIEW_NEEDS_DEFAULT_MAP_CENTER](state, payload = true) {
    state.bookMap.viewNeedsDefaultMapCenter = payload;
  },
};

export const ACTIONS = {
  OPEN_BOOK_MAP_INFORMER: 'openBookMapInformer',
  CLOSE_BOOK_MAP_INFORMER: 'closeBookMapInformer',
  RESET_BOOK_MAP_MARKERS_AND_INFORMER: 'resetBookMapMarkers',
};
export const actions = {
  [ACTIONS.OPEN_BOOK_MAP_INFORMER]({ commit }) {
    commit(MUTATIONS.SET_INFORMER_DATA, {
      open: true,
    });
  },
  [ACTIONS.CLOSE_BOOK_MAP_INFORMER]({ commit }) {
    commit(MUTATIONS.SET_INFORMER_DATA, {
      open: false,
    });
  },
  [ACTIONS.RESET_BOOK_MAP_MARKERS_AND_INFORMER]({ commit, dispatch }) {
    // Close informer infowindow
    dispatch(ACTIONS.CLOSE_BOOK_MAP_INFORMER);

    // Remove Pick up marker from map
    commit(MUTATIONS.SET_PICK_UP_MARKER, {
      lat: '',
      lng: '',
    });

    // Remove drop off marker from map
    commit(MUTATIONS.SET_DROP_OFF_MARKER, {
      lat: '',
      lng: '',
    });
  },
};

export const GETTERS = {
  IS_BOOK_MAP_INFORMER_OPENED: 'isBookMapInformerOpened',
};
export const getters = {
  [GETTERS.IS_BOOK_MAP_INFORMER_OPENED](s) {
    return _.isBoolean(s.bookMap.informer.open)
      && s.bookMap.informer.open
      && _.isObject(s.bookMap.informer.position)
      && _.isNumber(s.bookMap.informer.position.lat)
      && s.bookMap.informer.position.lat !== 0
      && _.isNumber(s.bookMap.informer.position.lng)
      && s.bookMap.informer.position.lng !== 0;
  },
};

export const NAMESPACE = 'MAP';
export const FULL_NAMESPACE = `${VIEWS_MODULE_NAMESPACE}/MainModule/MAP/`;

const store = {
  namespaced: true,

  state,
  mutations,
  actions,
  getters,
};

export default store;
